
import type Vue from "vue"
import menuMixin from "@/mixins/menu"

export default menuMixin.extend({
  props: {
    value: { type: Boolean, default: false },
    menuBtnRef: { type: Object as VuePropType<Vue | null>, default: null },
  },

  computed: {
    isOpen: {
      get (): boolean {
        return this.value
      },

      set (isOpen: boolean) {
        this.$emit("input", isOpen)
      },
    },
  },

  mounted () {
    document.addEventListener("click", this.onDocumentClick)
  },

  beforeDestroy () {
    document.removeEventListener("click", this.onDocumentClick)
  },

  methods: {
    onDocumentClick (event: MouseEvent) {
      const containerRef = this.$refs.containerRef as HTMLDivElement
      if (!containerRef) return

      const target = event.target as Element
      if (!target) return

      const menuBtnRef = this.menuBtnRef?.$el
      if (!menuBtnRef) return

      if (menuBtnRef.contains(target)) return

      if (!containerRef.contains(target))
        this.isOpen = false
    },
  },
})
